export { PermissionsPage } from './Page'
export { PermissionsTable } from './Table'
export { PermissionsTemplateSection } from './Template'
export { PermissionViewModal } from './ViewModal'
